module.exports = __webpack_public_path__ + "img/gb-banner.482eb787.png";